/* ============================================================
   CRO 04 - Warenkorb-Upsell im Mini-Warenkorb (Drawer)
   Angelegt: 17.08.2026

   Auf der Warenkorb-SEITE wird der Upsell direkt in Liquid
   gerendert (sections/main-cart-footer.liquid).

   Im DRAWER geht das nicht ohne Eingriff in die 31 KB grosse
   Datei snippets/cart-drawer.liquid. Stattdessen holt dieses
   Script den fertig gerenderten Block ueber die Section
   Rendering API (/cart?section_id=cart-upsell) und haengt ihn
   hinter die Versand-Fortschrittsanzeige im Drawer.

   Ab 17.08.2026: Auf Bildschirmen bis 749 px passiert gar
   nichts - der Upsell ist dort bewusst deaktiviert, weil er
   im engen Warenkorb vom Checkout ablenkt. Das spart auf dem
   Handy zusaetzlich einen Netzwerk-Request.

   Faellt das Script aus, bleibt der Drawer unveraendert - es
   fehlt dann nur der Upsell.

   Rueckgaengig machen: diese Datei, assets/cro-cart-upsell.css
   und sections/cart-upsell.liquid loeschen, dazu die beiden
   Zeilen am Ende von snippets/meta-tags.liquid entfernen.
   ============================================================ */

(function () {
  'use strict';

  var SOURCE_URL = '/cart?section_id=cart-upsell';
  var MIN_WIDTH = 750;
  var loading = false;
  var timer = null;

  function isDesktop() {
    return window.innerWidth >= MIN_WIDTH;
  }

  function drawer() {
    return document.querySelector('cart-drawer');
  }

  function anchor() {
    var el = drawer();
    return el ? el.querySelector('shipping-message') : null;
  }

  function currentBlock() {
    var el = drawer();
    return el ? el.querySelector('[data-gk-upsell]') : null;
  }

  function refresh() {
    if (!isDesktop()) {
      var stale = currentBlock();
      if (stale) stale.remove();
      return;
    }

    var target = anchor();
    if (!target || loading) return;

    loading = true;
    fetch(SOURCE_URL)
      .then(function (response) {
        if (!response.ok) throw new Error('section request failed');
        return response.text();
      })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector('[data-gk-upsell]');
        var existing = currentBlock();
        var stillThere = anchor();

        if (existing) existing.remove();
        if (fresh && stillThere) {
          stillThere.insertAdjacentElement('afterend', fresh);
        }
      })
      .catch(function () {
        /* stillschweigend ignorieren - der Drawer funktioniert auch ohne */
      })
      .then(function () {
        loading = false;
      });
  }

  function scheduleRefresh() {
    if (timer) clearTimeout(timer);
    timer = setTimeout(refresh, 200);
  }

  /* --- Aenderungen im Drawer beobachten --------------------- */
  function watch() {
    var el = drawer();
    if (!el) return;

    new MutationObserver(function (mutations) {
      if (loading) return;

      var relevant = mutations.some(function (mutation) {
        var node = mutation.target;
        return !(node.closest && node.closest('[data-gk-upsell]'));
      });

      if (relevant) scheduleRefresh();
    }).observe(el, { childList: true, subtree: true });

    window.addEventListener('resize', scheduleRefresh);

    scheduleRefresh();
  }

  /* --- Hinzufuegen aus dem Drawer heraus -------------------- */
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('.gk-upsell__form');
    if (!form) return;

    var el = drawer();
    if (!el || !form.closest('cart-drawer')) return;
    if (typeof el.renderContents !== 'function') return;

    event.preventDefault();

    var button = form.querySelector('.gk-upsell__button');
    var variantId = form.querySelector('input[name="id"]');
    if (!variantId) return;

    if (button) button.setAttribute('aria-busy', 'true');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(variantId.value), quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (data && data.sections) {
          el.renderContents(data);
          scheduleRefresh();
        } else {
          form.submit();
        }
      })
      .catch(function () {
        form.submit();
      })
      .then(function () {
        if (button) button.removeAttribute('aria-busy');
      });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
